export const primaryFont = 'Raleway, sans-serif'
export const secondaryFont = 'Montserrat, sans-serif'

export const regularWeight = 400
export const primaryBoldWeight = 600
export const secondaryBoldWeight = 500
